import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 3.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2ZM7.4 6a4.6 4.6 0 1 1 9.2 0 4.6 4.6 0 0 1-9.2 0ZM4.17 14.89c1.82-1.413 4.46-2.212 7.83-2.212s6.01.799 7.83 2.212c1.843 1.43 2.77 3.433 2.77 5.624 0 1.051-.79 2.087-1.979 2.087H3.38c-1.19 0-1.979-1.036-1.979-2.087 0-2.19.927-4.194 2.77-5.624Zm1.226 1.58C4.05 17.513 3.4 18.928 3.4 20.513c0 .042.011.071.021.087H20.58a.17.17 0 0 0 .021-.087c0-1.585-.65-3-1.996-4.044-1.367-1.061-3.528-1.792-6.604-1.792s-5.237.73-6.604 1.792Z"
  />,
  'UserProfile2'
)
